<template>
  <div class="login-container">
    <h2>Login</h2>
    <form @submit.prevent="login" class="login-form">
      <label>Email:</label>
      <input v-model="email" type="email" placeholder="Enter email" />

      <label>Password:</label>
      <input
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Enter password"
      />

      <div class="checkbox-row">
        <input type="checkbox" v-model="showPassword" id="showPassword" />
        <label for="showPassword">Show Password</label>
      </div>

      <button type="submit" class="sign-in-btn">SIGN IN</button>
    </form>

    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import API from "../services/api";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      error: ""
    };
  },
  methods: {
    async login() {
      try {
        const res = await API.post("/auth/login", {
          email: this.email,
          password: this.password
        });

        // Save token
        localStorage.setItem("token", res.data.token);

        // Redirect back to intended route or default to dashboard
        const redirectPath = this.$route.query.redirect || "/dashboard";
        this.$router.push(redirectPath);
      } catch (err) {
        this.error = err.response?.data?.msg || "Login failed";
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 350px;
  margin: auto;
  margin-top: 10%;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
}

.login-container h2 {
  text-align: center;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.login-form label {
  margin-top: 10px;
  font-weight: bold;
}

.login-form input {
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.sign-in-btn {
  margin-top: 15px;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.sign-in-btn:hover {
  background: #0056b3;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>
